import { render, staticRenderFns } from "./TagFilter.vue?vue&type=template&id=edc5d504&scoped=true"
import script from "./TagFilter.vue?vue&type=script&lang=js"
export * from "./TagFilter.vue?vue&type=script&lang=js"
import style0 from "./TagFilter.vue?vue&type=style&index=0&id=edc5d504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc5d504",
  null
  
)

export default component.exports